const EVENT_CODES = {
  PLAYER: 0,
  PLAYER_MOVE: 1,
  PLAYER_INVIS: 2,
  BULLET: 3,
  POWERUP: 4,
};


function decodePlayerEvent(view, offset) {
  return {
    event: {
      type: view.getUint8(offset),
      startTime: view.getUint32(offset + 1),
      endTime: view.getUint32(offset + 5),
      id: view.getUint16(offset + 9),
      real: view.getInt8(offset + 11) !== 0,
    },
    nextOffset: offset + 12,
  }
}

function decodeBulletEvent(view, offset){
  return {
    event: {
      type: view.getUint8(offset),
      startTime: view.getUint32(offset + 1),
      x: view.getUint16(offset + 5),
      y: view.getUint16(offset + 7),
      toX: view.getUint16(offset + 9),
      toY: view.getUint16(offset + 11),
    },
    nextOffset: offset + 13,
  }
}

function decodePowerupEvent(view, offset) {
  return {
    event: {
      type: view.getUint8(offset),
      startTime: view.getUint32(offset + 1),
      endTime: view.getUint32(offset + 5),
      x: view.getUint16(offset + 9),
      y: view.getUint16(offset + 11),
    },
    nextOffset: offset + 13,
  }
}

function decodePlayerMoveEvent(view, offset){
  return {
    event: {
      type: view.getUint8(offset),
      startTime: view.getUint32(offset + 1),
      id: view.getUint16(offset + 5),
      toX: view.getUint16(offset + 7),
      toY: view.getUint16(offset + 9),
    },
    nextOffset: offset + 11,
  }
}

function decodePlayerInvisEvent(view, offset) {
  return {
    event: {
      type: view.getUint8(offset),
      startTime: view.getUint32(offset + 1),
      id: view.getUint16(offset + 5),
    },
    nextOffset: offset + 7,
  }
}

function decodeEvents(view, offset, totalSize) {
  const events = [];
  while(offset < totalSize) {
    const type = view.getUint8(offset);
    offset = (() => {
      let out;
      switch (type) {
        case EVENT_CODES.PLAYER:
          out = decodePlayerEvent(view, offset);
          events.push(out.event);
          return out.nextOffset;
        case EVENT_CODES.BULLET:
          out = decodeBulletEvent(view, offset);
          events.push(out.event);
          return out.nextOffset;
        case EVENT_CODES.PLAYER_INVIS:
          out = decodePlayerInvisEvent(view, offset);
          events.push(out.event);
          return out.nextOffset;
        case EVENT_CODES.PLAYER_MOVE:
          out = decodePlayerMoveEvent(view, offset);
          events.push(out.event);
          return out.nextOffset;
        case EVENT_CODES.POWERUP:
          out = decodePowerupEvent(view, offset);
          events.push(out.event);
          return out.nextOffset;
        }
      }
    )();
  };
  return events;
}

function decodeHeader(view) {
  return {
    header: {
      version: view.getUint8(0),
      moveSeed: view.getUint16(1),
      firstStep: view.getUint8(3),
      endTime: view.getUint32(4),
    },
    nextOffset: 8,
  }
}

function decodeReplay(arr) {
  const view = new DataView(arr);
  const { header, nextOffset } = decodeHeader(view);
  const events = decodeEvents(view, nextOffset, arr.byteLength);
  return {
    header,
    events,
  };
}

module.exports = {
  decodeReplay,
}
